// src/pages/AllEssens/AllEssensScreen.js
import React, { useEffect, useState } from 'react';
import { db } from '../../firebase';
import { collection, getDocs } from 'firebase/firestore';

function AllEssensScreen() {
  const [essensList, setEssensList] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const snapshot = await getDocs(collection(db, 'kodeessens'));
      const list = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setEssensList(list);
    };
    fetchData();
  }, []);

  return (
    <div className="bg-white text-black min-h-screen p-6">
      <h1 className="text-center text-2xl font-bold mb-6">
        All Created Kode-Essens™
      </h1>

      {essensList.map((essens, index) => (
        <div
          key={essens.id}
          className={`p-4 rounded-lg shadow mb-6 ${
            index === 0
              ? 'border-2 border-yellow-400 bg-white'
              : 'bg-gray-100'
          }`}
        >
          <p className="font-bold">#{index + 1}</p>
          <p><strong>Kjennetegn:</strong> {essens.kjennetegn || '***'}</p>
          <p><strong>Kodeord:</strong> {index === 0 ? essens.kodeord : '*****'}</p>
          <p><strong>Essens-setning:</strong> {index === 0 ? essens.essensSetning : '*****'}</p>
          <p><strong>Tilkallingsformel:</strong> {index === 0 ? essens.tilkallingsformel : '*****'}</p>
          {index !== 0 && <p className="italic text-gray-600">🔒 Anonym bruker</p>}
        </div>
      ))}
    </div>
  );
}

export default AllEssensScreen;
